/**
 * Компонент выбора оператора сравнения
 */

import { Select } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";

import { ZOperatorDefinition } from "../../types";
import { ControlWithError } from "../ControlWithError/ControlWithError";
import * as styles from "./OperatorSelector.module.less";

interface PropsOperatorSelector {
  /** Список доступных операторов */
  operators: ZOperatorDefinition[];

  /** Выбранный оператор (код) */
  value: string | null;

  /** Callback при выборе оператора */
  onChange: (operator: string | null) => void;

  /** Placeholder */
  placeholder?: string;

  /** Disabled состояние */
  disabled?: boolean;

  /** Текст ошибки */
  errorText?: string;
}

/**
 * Селектор оператора с читаемыми названиями
 */
export const OperatorSelector: React.FC<PropsOperatorSelector> = observer(
  ({
    operators,
    value,
    onChange,
    placeholder = "Выбор оператора",
    disabled,
    errorText,
  }) => {
    const options = operators.map((op) => ({
      label: (
        <div className={styles.optionRow}>
          <span>{op.label}</span>
          <span className={styles.optionCode}>{op.code}</span>
        </div>
      ),
      value: op.code,
      title: op.label,
    }));

    return (
      <ControlWithError errorText={errorText}>
        <Select
          className={styles.operatorSelector}
          value={value || undefined}
          onChange={(val) => onChange(val || null)}
          placeholder={placeholder}
          disabled={disabled}
          status={errorText ? "error" : undefined}
          optionLabelProp="title"
          optionFilterProp="title"
          showSearch={false}
          options={options}
          allowClear
        />
      </ControlWithError>
    );
  },
);
